import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import CommercialOfferModel from "../../viewModels/CommercialOffers/CommercialOfferModel";
import { ApplicationModel } from "../../viewModels/Applications/ApplicationModel";
import { CommercialOfferUpdateModel, GenerateCommercialOfferDocumentInput } from "./types";

type CommercialOfferPageState = {
  loading: boolean;
  loadingData: boolean;
  updateStatus: "idle" | "pending" | "success" | "error";
  commercialOffer?: CommercialOfferModel;
  generateDocumentModalOpen: boolean;
  generateDocumentModalLoading: boolean;
};

const initialState: CommercialOfferPageState = {
  loading: true,
  loadingData: true,
  updateStatus: "idle",
  commercialOffer: undefined,
  generateDocumentModalOpen: false,
  generateDocumentModalLoading: false,
};

const commercialOfferSlice = createSlice({
  name: "commercialOffer",
  initialState,
  reducers: {
    loadCommercialOffer(state, _action: PayloadAction<number>) {
      state.loading = true;
      state.loadingData = true;
    },
    loadCommercialOfferSuccess(state, action: PayloadAction<CommercialOfferModel>) {
      state.loading = false;
      state.loadingData = false;
      state.commercialOffer = action.payload;
    },
    loadCommercialOfferReject(state) {
      state.loading = false;
      state.loadingData = false;
    },
    resetState: () => initialState,

    updateCommercialOffer(state, _action: PayloadAction<CommercialOfferUpdateModel>) {
      state.loadingData = true;
      state.updateStatus = "pending";
    },
    updateCommercialOfferSuccess(state, action: PayloadAction<CommercialOfferModel>) {
      state.loadingData = false;
      state.updateStatus = "success";
      state.commercialOffer = action.payload;
    },
    updateCommercialOfferReject(state) {
      state.loadingData = false;
      state.updateStatus = "error";
    },

    createDeal(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    createDealSuccess(state) {
      state.loadingData = false;
    },
    createDealReject(state) {
      state.loadingData = false;
    },

    syncClientInfoSuccess(state, action: PayloadAction<ApplicationModel>) {
      if (state.commercialOffer) {
        state.commercialOffer.application = action.payload;
      }
    },

    openGenerateDocumentModal(state) {
      state.generateDocumentModalOpen = true;
    },
    closeGenerateDocumentModal(state) {
      state.generateDocumentModalOpen = false;
      state.generateDocumentModalLoading = false;
    },
    generateDocument(state, action: PayloadAction<GenerateCommercialOfferDocumentInput>) {
      state.generateDocumentModalLoading = true;
      if (action.payload.commercialOffer) {
        state.loadingData = true;
        state.updateStatus = "pending";
      }
    },
    generateDocumentSuccess(state) {
      state.generateDocumentModalOpen = false;
      state.generateDocumentModalLoading = false;
    },
    generateDocumentReject(state) {
      state.generateDocumentModalLoading = false;
      state.loadingData = false;
      if (state.updateStatus === "pending") {
        state.updateStatus = "error";
      }
    },
  },
});

export default commercialOfferSlice;
